import Home from '../actual-pages/home';

export default Home;
